<template>
  <!-- 第六部分下拉菜单部分 -->
  <div class="payment-sixth-border">
    <div class="payment-sixth-content-parent">
      <!-- 内容的标题 -->
      <div class="payment-sixth-content-title">You may be wondering…</div>
      <div class="payment-sixth-content-menu">
        <el-menu
        class="el-menu-vertical-demo"
        :unique-opened="isOpened">
          <el-submenu v-for="(item,index) in dataList" :key="index" :index="index+''">
            <template slot="title">
              <span>{{item.title}}</span>
            </template>
            <el-menu-item-group>
              <template slot="title">{{item.content}}<router-link v-if="index == '0'" :to="{path:'/privacy'}" style="text-decoration: none;color:blue;margin-left:10px">Privacy Policy</router-link></template>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpened: true,
      dataList: [
        {title: 'Why do I need my bank account when applying for activation?', content: 'We will assign terms to merchants when registering, and determine your initial net 60 terms limit based on the information you provide about your business type, size, and location. When you apply for an interest rate hike, we will ask you to provide financial information to verify your eligibility for additional credit. Your financial information and other business information allows us to better understand how your business operates. For more information, see our'},
        {title: 'How long is the approval process?', content: 'Once you apply, it takes about 1-2 business days for us to review your application and update your terms limit.'},
        {title: 'Can I still place new orders once I use all of my terms?', content: 'Yes! If you have used all our currently available terms, you can place additional orders and pay at the time of shipment. Or, if you find that you do not have enough conditions to order what your shop needs, you can pay by credit card or bank transfer, or you can contact us Apply for a salary increase'},
        {title: 'Can I pay off the invoice before  days?', content: 'Yes, you can pay the invoice at any time. Otherwise, your payment method will be automatically deducted at the end of the payment period.'},
        {title: 'How often can I apply for a salary increase?', content: 'You can apply for additional limits after using the quota, but we cannot guarantee that it will increase every time. We provide restrictions based on your current business information in order to extend the correct restrictions for your store’s purchasing needs.'},
        {title: 'Will using this limit affect my standing on ShopVidi?', content: 'As long as you pay your invoices on time, there is no penalty for using net terms on ShopVidi.'}
      ]
    }
  }
}
</script>

<style lang="less" scoped>
/* 第六部分 */
.payment-sixth-border{width: 100%;min-height: 300px;height: auto;}
.payment-sixth-content-parent{width: auto;max-width: 1400px;margin:0 auto}
.payment-sixth-content-title{font-size: 36px;font-family: STIXGeneral;font-weight: 400;line-height: 97px;color: #000000;opacity: 1;text-align: center;margin-top: 50px;}
.payment-sixth-content-menu{width: 50%;margin:0 auto}
.el-menu{border: none;}
/deep/ .el-submenu__title{padding-left: 0 !important;font-size: 16px !important;font-family: Graphik;font-weight: 500;color: #000000;opacity: 1;border-bottom:1px solid #E1E1E1}
/deep/ .el-submenu__title:hover{color: #000000 !important;}
/deep/ .el-menu-item-group__title{padding: 0 !important;font-size: 14px !important;font-family: Graphik !important;font-weight: 500 !important;line-height: 34px !important;color: #8F8F8F !important;opacity: 1 !important;}
@media screen and (max-width: 600px) {
  .payment-sixth-content-title{font-size: 28px;width: 80%;margin: 0 auto;}
  .payment-sixth-content-menu{width: 95%;margin:0 auto}
  /deep/ .el-submenu__title{font-size: 13px !important;display: flex !important;flex-flow: wrap !important;width: 100%;}
  /deep/ .el-menu-item-group__title{font-size: 13px !important}
  /deep/ .el-submenu__icon-arrow{right: 0px !important;}
}
</style>



// WEBPACK FOOTER //
// src/pages/credit-payment/payment-six.vue